import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Shield, Lock, Globe, Check, Zap, Sparkles } from 'lucide-react';
const comboIncludes = ['Todo lo del Mega Pack 360° (5 tomos + 4 bonos)', 'Vivero Tomo 1 — Fundamentos del Vivero y la Propagación', 'Vivero Tomo 2 — Propagación Vegetal: Semillas, Esquejes e Injertos', 'Vivero Tomo 3 — Manejo del Vivero, Sanidad y Proyecto Final del Vivero Escolar'];
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-cream relative" data-id="element-192">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-lg h-[500px] bg-forest/10 blur-[120px] rounded-full pointer-events-none" data-id="element-193"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-194">
        <div className="text-center mb-10" data-id="element-195">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-3 text-slate-900" data-id="element-196">
            Elegí tu pack
          </h2>
          <p className="text-earth text-sm md:text-base font-medium" data-id="element-197">
            Dos opciones. Mismo acceso inmediato.
          </p>
        </div>

        {/* OFERTA 1: MEGA PACK SOLO */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white border border-forest/30 rounded-3xl p-1 relative shadow-[0_0_30px_rgba(30,58,36,0.05)] mb-8" data-id="element-198">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-forest text-cream font-bold px-5 py-1.5 rounded-full shadow-lg uppercase tracking-wider text-xs" data-id="element-199">
            🏆 Oferta principal
          </div>

          <div className="bg-cream rounded-[1.3rem] p-6 md:p-10 text-center border border-white" data-id="element-200">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-forest mb-3" data-id="element-201">
              Mega Pack Producción Agropecuaria 360°
            </h3>
            <p className="text-base text-slate-700 mb-6" data-id="element-202">
              Los 5 tomos + 4 bonos estratégicos listos para usar en el aula.
            </p>

            <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-white border border-earth/10 rounded-xl p-4 shadow-sm" data-id="element-203">
              {['Tomo 1 — Fundamentos de la Producción Agropecuaria', 'Tomo 2 — Producción Vegetal y Ganadería Bovina', 'Tomo 3 — Riego, Maquinaria y Seguridad Rural', 'Tomo 4 — Sustentabilidad y Producción Animal', 'Tomo 5 — Del Campo al Mercado', 'Bono 1 — Clases organizadas y listas para usar', 'Bono 2 — Actividades prácticas para el aula y el taller', 'Bono 3 — Evaluaciones y criterios de corrección', 'Bono 4 — Proyectos Finales Productivos'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-slate-700" data-id="element-204">
                  <Check size={16} className="text-forest shrink-0 mt-0.5" data-id="element-205" />
                  <span data-id="element-206">{item}</span>
                </li>)}
            </ul>

            <div className="mb-6" data-id="element-207">
              <span className="text-lg text-slate-500 line-through block mb-1" data-id="element-208">
                USD 45,00
              </span>
              <div className="flex items-baseline justify-center gap-2" data-id="element-209">
                <span className="text-2xl md:text-3xl text-slate-800" data-id="element-210">
                  Hoy:
                </span>
                <span className="text-4xl md:text-5xl font-bold text-forest" data-id="element-211">
                  USD 19,90
                </span>
              </div>
            </div>

            <Button href="https://ktdgr0-mw.myshopify.com/cart/48062766743770:1" target="_blank" onLinkClick={() => {
            if (typeof window !== 'undefined' && (window as any).fbq) {
              ;
              (window as any).fbq('track', 'InitiateCheckout', {
                content_name: 'Mega Pack Producción Agropecuaria 360',
                value: 19.9,
                currency: 'USD'
              });
            }
          }} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-212">
              🟡 QUIERO EL MEGA PACK
            </Button>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-slate-600 font-medium" data-id="element-213">
              <span className="flex items-center gap-1.5" data-id="element-214">
                <Lock size={12} className="text-forest" data-id="element-215" /> Pago seguro
              </span>
              <span className="flex items-center gap-1.5" data-id="element-216">
                <Zap size={12} className="text-forest" data-id="element-217" /> Acceso inmediato
              </span>
              <span className="flex items-center gap-1.5" data-id="element-218">
                <Shield size={12} className="text-forest" data-id="element-219" /> Garantía 7 días
              </span>
            </div>
          </div>
        </motion.div>

        {/* OFERTA 2: MEGA PACK + DISCIPLINAS */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="bg-white border-2 border-gold rounded-3xl p-1 relative shadow-[0_0_50px_rgba(212,175,55,0.15)]" data-id="element-220">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold-gradient text-black font-bold px-5 py-1.5 rounded-full shadow-lg uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap" data-id="element-221">
            <Sparkles size={14} data-id="element-222" /> Más elegido · Mejor valor
          </div>

          <div className="bg-cream rounded-[1.3rem] p-6 md:p-10 text-center border border-white" data-id="element-223">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-forest mb-3" data-id="element-224">
              Mega Pack Producción Agropecuaria 360° + Mega Pack Vivero y
              Propagación Vegetal 360°
            </h3>
            <p className="text-base text-slate-700 mb-6" data-id="element-225">
              Llevás el pack completo más el sistema completo para montar y
              enseñar un vivero escolar productivo desde cero.
            </p>

            <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-white border border-gold/30 rounded-xl p-4 shadow-sm" data-id="element-226">
              {comboIncludes.map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-slate-700" data-id="element-227">
                  <Check size={16} className="text-gold shrink-0 mt-0.5" data-id="element-228" />
                  <span className={i === 0 ? 'font-bold' : ''} data-id="element-229">{item}</span>
                </li>)}
            </ul>

            <div className="mb-6" data-id="element-230">
              <span className="text-lg text-slate-500 line-through block mb-1" data-id="element-231">
                USD 72,90
              </span>
              <div className="flex items-baseline justify-center gap-2" data-id="element-232">
                <span className="text-2xl md:text-3xl text-slate-800" data-id="element-233">
                  Hoy:
                </span>
                <span className="text-4xl md:text-5xl font-bold text-forest" data-id="element-234">
                  USD 27,90
                </span>
              </div>
            </div>

            <Button href="https://ktdgr0-mw.myshopify.com/cart/48062770872538:1" target="_blank" onLinkClick={() => {
            if (typeof window !== 'undefined' && (window as any).fbq) {
              ;
              (window as any).fbq('track', 'InitiateCheckout', {
                content_name: 'Mega Pack Producción Agropecuaria 360 + Vivero',
                value: 27.9,
                currency: 'USD'
              });
            }
          }} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-235">
              🟡 LLEVAR PACK COMPLETO
            </Button>

            <div className="bg-white border border-earth/10 rounded-xl p-3 max-w-md mx-auto flex items-start gap-2.5 text-left shadow-sm" data-id="element-236">
              <Globe className="text-forest shrink-0 mt-0.5" size={14} data-id="element-237" />
              <p className="text-[11px] text-slate-600 leading-snug" data-id="element-238">
                Pagás en tu moneda local. El importe se adapta automáticamente
                al país desde donde comprás.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}